import dayjs from 'dayjs'
import { ReactElement } from 'react'
import { Box, Card, Skeleton, Typography } from '@mui/material'
import type { TrainingSeries } from 'src/v3/core/types'

type TrainingSeriesDetailsCardProps = {
  trainingSeries: TrainingSeries | null
  linkedServiceName: string
  isLoading: boolean
}

function TrainingSeriesDetailsCardSkeleton(): ReactElement {
  return (
    <Card className="p-6 mb-6">
      <Typography variant="h6" component="h2" className="mb-4">
        Training Series Information
      </Typography>
      <Box className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Skeleton variant="rounded" height={56} />
        <Skeleton variant="rounded" height={56} />
        <Skeleton variant="rounded" height={56} />
        <Skeleton variant="rounded" height={56} />
      </Box>
    </Card>
  )
}

export default function TrainingSeriesDetailsCard({
  trainingSeries,
  linkedServiceName,
  isLoading,
}: TrainingSeriesDetailsCardProps): ReactElement {
  if (isLoading || !trainingSeries) {
    return <TrainingSeriesDetailsCardSkeleton />
  }

  return (
    <Card className="p-6 mb-6">
      <Typography variant="h6" component="h2" className="mb-4">
        Training Series Information
      </Typography>
      <Box className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            className="mb-1"
            component="p"
          >
            Name
          </Typography>
          <Typography variant="body1" className="font-semibold">
            {trainingSeries.name}
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            className="mb-1"
            component="p"
          >
            Linked Service
          </Typography>
          <Typography variant="body1">{linkedServiceName}</Typography>
        </Box>
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            className="mb-1"
            component="p"
          >
            Created
          </Typography>
          <Typography variant="body1">
            {dayjs(trainingSeries.createdTime).format('MMM D, YYYY h:mm A')}
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            className="mb-1"
            component="p"
          >
            Last Updated
          </Typography>
          <Typography variant="body1">
            {dayjs(trainingSeries.updatedTime).format('MMM D, YYYY h:mm A')}
          </Typography>
        </Box>
      </Box>
    </Card>
  )
}
